module.exports = __webpack_public_path__ + "img/mhv.dcbc9e10.png";